export default "__VITE_ASSET__oXu5Rn68__"